import {getRouteApi} from "@tanstack/react-router";

export const representativeNotesRouteApi = getRouteApi(
  "/_app/sales/representatives/$representativeId/notes/",
);
